
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { Http, Response } from '@angular/http';
import { UtilsService } from "app/services/utils.service";
import { FooterCellListResource } from 'app/models/FooterCellListResource';
import { FooterCellResource } from 'app/models/FooterCellResource';
import { FooterCopyRightResource } from 'app/models/FooterCopyRightResource';
import { FooterBarLinkListResource } from 'app/models/FooterBarLinkListResource';
import { FooterBarLinkResource } from 'app/models/FooterBarLinkResource';
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class FooterConfigService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  getFooterCellList(url): Observable<FooterCellListResource> {
    return this.http.get<FooterCellListResource>(environment['url'] + url);
  }

  deleteFooterCell(url): Observable<FooterCellResource> {
    return this.http.get<FooterCellResource>(environment['url'] + url)
  }

  deleteFooterPagesService(url): Observable<FooterBarLinkResource> {
    return this.http.get<FooterBarLinkResource>(environment['url'] + url);
  }

  private FooterListResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }

  private FooterBarLinkListResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }

  saveEditFooterCopyright(url, body): Observable<FooterCopyRightResource> {
    return this.http.post<FooterCopyRightResource>(environment['url'] + url, body);
  }

  getFooterCopyrightText(url): Observable<FooterCopyRightResource> {
    return this.http.get<FooterCopyRightResource>(environment['url'] + url);
  }

  getCellActive(url): Observable<FooterCellListResource> {
    return this.http.get<FooterCellListResource>(environment['url']+ url);
  }


  shiftElements(url, body): Observable<any> {
    return this.http.post<any>(environment['url'] + url, body);
  }

  getFooterPagesService(url): Observable<FooterBarLinkListResource> {
    return this.http.get<FooterBarLinkListResource>(environment['url'] + url);
  }
}
